const internalContentPath = /^\/(?:question|faq|article|document|sondage)\/[^/?#]+(?:[?#].*)?$/
// Opens the AI assistant in the mobile app; it takes no uuid.
const aiAssistantPath = /^\/assistant\/?(?:[?#].*)?$/
const legacyInternalHost = /^(?:question|faq|article|document|sondage|assistant)$/
const appHostname = /^(?:app|admin|bo|m)(?:[.-][a-z0-9-]+)*\.(?:maviepro\.net|tract-app\.com)$/

function currentLocation () {
  if (typeof window !== 'undefined' && window.location) return window.location
  return { href: 'https://app.maviepro.net/', hostname: 'app.maviepro.net' }
}

function isLocalHostname (hostname) {
  return hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '::1' ||
    hostname.endsWith('.localhost')
}

function isInternalAppHostname (hostname, currentHostname) {
  const normalizedHostname = (hostname || '').toLowerCase()
  const normalizedCurrentHostname = (currentHostname || '').toLowerCase()

  return normalizedHostname === normalizedCurrentHostname ||
    (isLocalHostname(normalizedHostname) && isLocalHostname(normalizedCurrentHostname)) ||
    appHostname.test(normalizedHostname)
}

export function normalizeInternalContentHref (href) {
  const value = String(href || '').trim()
  if (!value) return null

  let path = value
  if (/^https?:\/\//i.test(value) || value.indexOf('//') === 0) {
    try {
      const location = currentLocation()
      const url = new URL(value, location.href)
      const hostname = url.hostname.toLowerCase()

      // Older versions of the Quill formatter could turn /document/uuid
      // into http:///document/uuid (parsed by browsers as host "document").
      if (legacyInternalHost.test(hostname)) {
        path = `/${hostname}${url.pathname}${url.search}${url.hash}`
      } else {
        if (!isInternalAppHostname(hostname, location.hostname)) return null
        path = `${url.pathname}${url.search}${url.hash}`
      }
    } catch (e) {
      return null
    }
  } else if (value.indexOf('/') !== 0) {
    path = `/${value}`
  }

  if (aiAssistantPath.test(path)) return path.replace(/^\/assistant\//, '/assistant')

  return internalContentPath.test(path) ? path : null
}

export function normalizeQuillLink (href) {
  const value = String(href || '').trim()
  const internalHref = normalizeInternalContentHref(value)
  if (internalHref) return internalHref

  if (/^(?:https?:|mailto:|tel:)/i.test(value) ||
    value.indexOf('//') === 0 ||
    value.indexOf('/') === 0 ||
    value.indexOf('#') === 0) {
    return value
  }

  return `http://${value}`
}

export function normalizeInternalContentLinks (html) {
  if (!html || typeof document === 'undefined') return html

  const container = document.createElement('div')
  container.innerHTML = html
  container.querySelectorAll('a[href]').forEach(anchor => {
    const normalizedHref = normalizeInternalContentHref(anchor.getAttribute('href'))
    if (normalizedHref) {
      anchor.setAttribute('href', normalizedHref)
    }
  })

  return container.innerHTML
}
